import { SITE } from "@/lib/site";

/**
 * Default FAQ entries used on every city page.
 * Use {city} as a placeholder for the city name.
 */
export const cityFAQs = (cityName) => [
  {
    q: `How much does pressure washing cost in ${cityName}, OH?`,
    a: `${cityName} jobs typically run $169–$399 depending on home size and scope. House washes start around $169–$229, a 2-car driveway is $99–$159, and a typical gutter clean-out is $119–$179. Larger homes scale up — every quote is free, fixed, and honored as written. Call ${SITE.phone} for an exact number.`,
  },
  {
    q: `Is pressure washing safe for vinyl siding in ${cityName}?`,
    a: `Yes — when it's done correctly. We use a low-pressure soft-wash system with biodegradable detergents that lift mildew and algae without forcing water behind the siding. We never use a high-pressure tip on vinyl, and we never spray upward into the panels.`,
  },
  {
    q: `How long does a typical job take?`,
    a: `Most ${cityName} jobs are completed in 1–3 hours. House washes average 90 minutes, driveways 60–90 minutes, and gutter clean-outs 30–60 minutes depending on the home's footprint.`,
  },
  {
    q: `Do you protect plants and outdoor furniture?`,
    a: `Always. We pre-rinse and protect landscaping before applying any cleaning solution, and we ask you to move loose furniture or pets indoors. Our detergents are plant-safe when properly diluted and rinsed — which is exactly how we use them.`,
  },
  {
    q: `How quickly can you schedule a ${cityName} appointment?`,
    a: `Same-week scheduling is the norm in ${cityName}. We typically have openings within 3–7 days. Submit the quote form or call ${SITE.phone} and we'll text you available windows the same day.`,
  },
];
